import { render, staticRenderFns } from "./backend-template.vue?vue&type=template&id=4620adfa&"
import script from "./backend-template.vue?vue&type=script&lang=js&"
export * from "./backend-template.vue?vue&type=script&lang=js&"
import style0 from "./backend-template.vue?vue&type=style&index=0&id=4620adfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports